/**
 * Components Re-Export File
 * All components have been extracted to their own files in ./components/
 * This file re-exports them for backward compatibility with App.js
 */

import UserLogin from './components/auth/UserLogin';
import UserRegister from './components/auth/UserRegister';
import Header from './components/Header';
import Navigation from './components/Navigation';
import ExploreHub from './components/ExploreHub';
import TranslationInterface from './components/TranslationInterface';
import AdminLogin from './components/AdminLogin';
import AdminPanel from './components/AdminPanel';
import UserProfileBadge from './components/UserProfileBadge';
import UserProfile from './components/UserProfile';
import FlagDisplay from './components/FlagDisplay';
import MaintenancePage from './components/MaintenancePage';
import MusicPage from './components/MusicPage';
import FavoritesPage from './components/FavoritesPage';
import RequestWordPage from './components/RequestWordPage';
import ProgressPage from './components/ProgressPage';
import CulturePodPage from './components/CulturePodPage';
import GamesSection from './components/GamesSection';
import MusicAdminPanel from './components/admin/MusicAdminPanel';
import CulturePodAdminPanel from './components/admin/CulturePodAdminPanel';
import ConversationModal from './components/ConversationModal';
import ConversationChallengeCard from './components/ConversationChallengeCard';

export {
  Header,
  Navigation,
  ExploreHub,
  TranslationInterface,
  AdminLogin,
  AdminPanel,
  UserProfileBadge,
  UserProfile,
  FlagDisplay,
  MaintenancePage,
  MusicPage,
  MusicAdminPanel,
  FavoritesPage,
  RequestWordPage,
  ProgressPage,
  CulturePodPage,
  CulturePodAdminPanel,
  GamesSection,
  ConversationModal,
  ConversationChallengeCard,
  UserLogin,
  UserRegister,
};

export const Components = {
  Header,
  Navigation,
  TranslationInterface,
  ExploreHub,
  AdminLogin,
  AdminPanel,
  MaintenancePage,
  FlagDisplay,
  UserRegister,
  UserLogin,
  UserProfileBadge,
  UserProfile,
  FavoritesPage,
  RequestWordPage,
  ProgressPage,
  MusicAdminPanel,
  MusicPage,
  CulturePodAdminPanel,
  CulturePodPage,
  GamesSection,
};
